/** Max parallel file fetches. */
export const CONTRACTOR_CARDS_DOWNLOAD_CONCURRENCY = 4;
